import { Route } from 'react-router-dom';

// Routes
import { AuthRouteKeys } from 'src/utils/constants/routes';

// Components
import { AuthProvider } from 'src/contexts/AuthContext';
import NoAuthProvider from 'src/contexts/NoAuthContext';
import FormBulkUploadStep3 from 'src/features/AIHSCodeLabeling/FormBulkUploadStep3';
import SinglePrediction from 'src/features/AIHSCodeLabeling/SinglePrediction';
import CompanyPrintPage from 'src/features/CompanyDetail/PrintPage';
import VesselDetailPage from 'src/pages/VesselDetail';
import ActivitiesPage from 'src/pages/Activities';
import AIHSCodeLabelingPage from 'src/pages/AIHSCodeLabeling';
import MyReportPage from 'src/pages/AiReport';
import BillOfLadingDetailPage from 'src/pages/BillOfLadingDetail';
import BookmarkPage from 'src/pages/Bookmark';
import CalendarBooking from 'src/pages/CalendarBooking';
import CheckoutPage from 'src/pages/Checkout';
import CompanyDetailPage from 'src/pages/CompanyDetail';
import CompanyProfilesPage from 'src/pages/CompanyProfiles';
import CompanyTradeDataPage from 'src/pages/CompanyTradeData';
import CompareCompanyPage from 'src/pages/CompareCompany';
import ContributionDetailPage from 'src/pages/ContributionDetail';
import ContributionsPage from 'src/pages/Contributions';
import HomePage from 'src/pages/Home';
import PortsPage from 'src/pages/ListPorts';
import OnboardingPage from 'src/pages/Onboarding';
import OrderConfirmationPage from 'src/pages/OrderConfirmation';
import PeopleDetailPage from 'src/pages/PeopleDetail';
import PeopleProfilesPage from 'src/pages/PeopleProfiles';
import PortDetailPage from 'src/pages/PortDetail';
import PricingPage from 'src/pages/Pricing';
import SanctionDetailPage from 'src/pages/SanctionDetail';
import SanctionsPage from 'src/pages/Sanctions';
import SettingPage from 'src/pages/Setting';
import TariffRulesPage from 'src/pages/TariffsAndRules';
import TradeDataPage from 'src/pages/TradeData';
import TradeDataProductListPage from 'src/pages/TradeDataProductList';
import VesselsPage from 'src/pages/Vessels';

const AuthRoutes = [
  <Route
    key={AuthRouteKeys.Home}
    path={AuthRouteKeys.Home}
    element={
      <AuthProvider>
        <HomePage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.CompanyDetail}
    path={AuthRouteKeys.CompanyDetail}
    element={
      <AuthProvider>
        <CompanyDetailPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.CompanyProfiles}
    path={AuthRouteKeys.CompanyProfiles}
    element={
      <AuthProvider>
        <CompanyProfilesPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.Onboarding}
    path={AuthRouteKeys.Onboarding}
    element={
      <AuthProvider>
        <OnboardingPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.Setting}
    path={AuthRouteKeys.Setting}
    element={
      <AuthProvider>
        <SettingPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.PeopleProfiles}
    path={AuthRouteKeys.PeopleProfiles}
    element={
      <AuthProvider>
        <PeopleProfilesPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.PeopleDetail}
    path={AuthRouteKeys.PeopleDetail}
    element={
      <AuthProvider>
        <PeopleDetailPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.Bookmark}
    path={AuthRouteKeys.Bookmark}
    element={
      <AuthProvider>
        <BookmarkPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.CompareCompany}
    path={AuthRouteKeys.CompareCompany}
    element={
      <AuthProvider>
        <CompareCompanyPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.TariffsAndRules}
    path={AuthRouteKeys.TariffsAndRules}
    element={
      <AuthProvider>
        <TariffRulesPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.Port}
    path={AuthRouteKeys.Port}
    element={
      <AuthProvider>
        <PortsPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.BillOfLadingDetail}
    path={AuthRouteKeys.BillOfLadingDetail}
    element={
      <AuthProvider>
        <BillOfLadingDetailPage />
      </AuthProvider>
    }
  />,

  <Route
    key={AuthRouteKeys.TradeData}
    path={AuthRouteKeys.TradeData}
    element={
      <AuthProvider>
        <TradeDataPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.TradeDataProductList}
    path={AuthRouteKeys.TradeDataProductList}
    element={
      <AuthProvider>
        <TradeDataProductListPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.Pricing}
    path={AuthRouteKeys.Pricing}
    element={
      <AuthProvider>
        <PricingPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.Checkout}
    path={AuthRouteKeys.Checkout}
    element={
      <AuthProvider>
        <CheckoutPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.OrderConfirmation}
    path={AuthRouteKeys.OrderConfirmation}
    element={
      <AuthProvider>
        <OrderConfirmationPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.CalendarBooking}
    path={AuthRouteKeys.CalendarBooking}
    element={
      <AuthProvider>
        <CalendarBooking />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.AIHSCodeSearch}
    path={AuthRouteKeys.AIHSCodeSearch}
    element={
      <AuthProvider>
        <AIHSCodeLabelingPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.PortDetail}
    path={AuthRouteKeys.PortDetail}
    element={
      <AuthProvider>
        <PortDetailPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.AIHSCodeSearchResult}
    path={AuthRouteKeys.AIHSCodeSearchResult}
    element={
      <AuthProvider>
        <SinglePrediction />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.PortDetail}
    path={AuthRouteKeys.PortDetail}
    element={
      <AuthProvider>
        <PortDetailPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.AIHSCodeBulkResult}
    path={AuthRouteKeys.AIHSCodeBulkResult}
    element={
      <AuthProvider>
        <FormBulkUploadStep3 />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.Activities}
    path={AuthRouteKeys.Activities}
    element={
      <AuthProvider>
        <ActivitiesPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.Vessels}
    path={AuthRouteKeys.Vessels}
    element={
      <AuthProvider>
        <VesselsPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.VesselDetail}
    path={AuthRouteKeys.VesselDetail}
    element={
      <AuthProvider>
        <VesselDetailPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.Contribution}
    path={AuthRouteKeys.Contribution}
    element={
      <AuthProvider>
        <ContributionsPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.ContributionDetail}
    path={AuthRouteKeys.ContributionDetail}
    element={
      <AuthProvider>
        <ContributionDetailPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.Sanctions}
    path={AuthRouteKeys.Sanctions}
    element={
      <AuthProvider>
        <SanctionsPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.SanctionDetail}
    path={AuthRouteKeys.SanctionDetail}
    element={
      <AuthProvider>
        <SanctionDetailPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.AiReport}
    path={AuthRouteKeys.AiReport}
    element={
      <AuthProvider>
        <MyReportPage />
      </AuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.CompanyPrintPage}
    path={AuthRouteKeys.CompanyPrintPage}
    element={
      <NoAuthProvider>
        <CompanyPrintPage />
      </NoAuthProvider>
    }
  />,
  <Route
    key={AuthRouteKeys.CompanyTradeData}
    path={AuthRouteKeys.CompanyTradeData}
    element={
      <AuthProvider>
        <CompanyTradeDataPage />
      </AuthProvider>
    }
  />,
];

export default AuthRoutes;
